
export const SET_TOMADOR = 'BACKUP_TOMADOR';